// @ts-nocheck

import { createSelector } from 'reselect';

import { selectRuntimeLicence } from '../../../../selectors/runtime/runtimePrimary.selector';
import { MPAllowedLicences, MPVersion } from '../../constants/runtime';
import { MPGlobalStatuses } from '../../types/global';
import { MPUserStatuses } from '../../types/user';
import { selectMPGlobalStatus, selectMPGlobalVersion } from '../global';
import { selectMPUserStatus } from '../user';

export const selectIsMPEnabled = createSelector(
  [selectRuntimeLicence, selectMPUserStatus, selectMPGlobalVersion, selectMPGlobalStatus],
  (licence, userStatus, version, globalStatus) => {
    return (
      (globalStatus === MPGlobalStatuses.RUNNING || globalStatus === MPGlobalStatuses.ENDING) &&
      version === MPVersion &&
      MPAllowedLicences.includes(licence) &&
      userStatus !== MPUserStatuses.EXCLUDED
    );
  },
);
